// import React, { useEffect, useState } from 'react';
// import axios, { renderDoc, decryptData } from '../Axiosinstance';
// import { useParams } from 'react-router-dom';
// import {  Modal } from 'react-bootstrap';
// import Loader from '../Loader'
// import Paper from '@mui/material/Paper';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
// import TableRow from '@mui/material/TableRow';
// import * as XLSX from 'xlsx';
// import SaveAltIcon from '@mui/icons-material/SaveAlt';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { baseURLdyte, Password, Username } from '../common'
// import Button from '@mui/material/Button';

// const BatchDetails = () => {
//   const { batchId, intakeId } = useParams();
//   const batchId1 = decryptData(decodeURIComponent(batchId))
//   const intakeId1 = decryptData(decodeURIComponent(intakeId))
//   const [batchDetails, setBatchDetails] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [matchingSessions, setMatchingSessions] = useState([]);
//   const [selectedSessionId, setSelectedSessionId] = useState(null);
//   const [sessionDetails, setSessionDetails] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [matchingBatches, setMatchingBatches] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5); // Set the number of sessions per page
//   const [intakedata, setIntakedata] = useState([]);

//   // Calculate the indexes for the current page
//   const indexOfLastSession = (page + 1) * rowsPerPage;
//   const indexOfFirstSession = indexOfLastSession - rowsPerPage;
//   const currentSessions = matchingSessions.slice(indexOfFirstSession, indexOfLastSession);

//   // Function to handle page change
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   // Function to handle rows per page change
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   useEffect(() => {
//     const fetchBatchDetails = async () => {
//       try {
//         const response = await axios.get(`batch/${batchId1}`);
//         setBatchDetails(response.data);
//       } catch (error) {
//         console.error('Error fetching batch details:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBatchDetails();
//   }, [batchId1]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(`/intake-details/intake/${intakeId1}`);
//         if (response.data) {
//           setIntakedata(response.data);
//           setLoading(false);
//         } else {
//           throw new Error('Data format is incorrect');
//         }
//       } catch (error) {
//         console.error('Fetch error:', error);
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [intakeId1]);

//   useEffect(() => {
//     const fetchSessions = async () => {
//       try {
//         const orgId = Username;
//         const apiKey = Password;
//         const authHeader = `Basic ${btoa(`${orgId}:${apiKey}`)}`;

//         const sessionsResponse = await axios.get(`${baseURLdyte}/sessions`, {
//           headers: {
//             Authorization: authHeader,
//           },
//         });

//         const sessions = sessionsResponse.data.data.sessions;

//         if (batchDetails && sessions) {
//           const url = batchDetails.onlineclasslink
//           const match = url.match(/id=([a-f\d-]+)/i);

//           if (match && match[1]) {
//             const meetingId = match[1];

//             const matchingSessions = sessions.filter(
//               session => session.meta.room_name === meetingId
//             );

//             setMatchingSessions(matchingSessions);
//             console.log(matchingSessions)
//           } else {
//             console.warn('Meeting ID not found in onlineclasslink');
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching sessions:', error);
//       }
//     };

//     fetchSessions();
//   }, [batchDetails]);

//   const handleSessionButtonClick = async (sessionId) => {
//     setSelectedSessionId(sessionId);
//     setShowModal(true);

//     try {
//       const orgId = Username;
//       const apiKey = Password;
//       const authHeader = `Basic ${btoa(`${orgId}:${apiKey}`)}`;

//       const response = await axios.get(`${baseURLdyte}/sessions/${sessionId}/participants`, {
//         headers: {
//           Authorization: authHeader,
//         },
//       });

//       const participantsData = response.data.data.participants;
//       setSessionDetails(participantsData);
//       console.log("hello", JSON.stringify(participantsData))
//     } catch (error) {
//       console.error('Error fetching session details:', error);
//     }
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//   };

//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   const convertSecondsToMinutes = (seconds) => {
//     return (seconds / 60).toFixed(2); // Round to 2 decimal places
//   };

//   function formatToDDMMYYYY(dateString) {
//     if (!dateString) return 'Invalid Date'; // Handle undefined or null input

//     const date = new Date(dateString);

//     if (isNaN(date)) return 'Invalid Date'; // Handle invalid date strings

//     const day = String(date.getDate()).padStart(2, '0'); // Add leading zero
//     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
//     const year = date.getFullYear();

//     return `${day}/${month}/${year}`;
//   }


//   const downloadSessionDetailsToExcel = () => {
//     const workbook = XLSX.utils.book_new();

//     // Combine batch and session details into a single sheet
//     const sheetData = [

//       {
//         'Course': batchDetails.course || 'N/A', // Default to 'N/A' if course is missing
//         'Intake': intakeId1 || 'N/A', // Default to 'N/A' if intakeId1 is missing
//         'Trainers': Array.isArray(intakedata.trainers) && intakedata.trainers.length > 0
//           ? intakedata.trainers.join(', ')
//           : 'N/A', // Handle case when trainers are missing or not an array

//         'Course Start Date': intakedata.scheduleDateDetails?.[0]?.startDate
//           ? formatToDDMMYYYY(intakedata.scheduleDateDetails[0].startDate)
//           : 'N/A', // Check if startDate exists

//         'Course End Date': intakedata.scheduleDateDetails?.length > 0
//           ? formatToDDMMYYYY(intakedata.scheduleDateDetails[intakedata.scheduleDateDetails.length - 1].endDate)
//           : 'N/A', // Check if there are schedule details and get the last endDate

//         'Assessors': Array.isArray(intakedata.assessors) && intakedata.assessors.length > 0
//           ? intakedata.assessors.join(', ')
//           : 'N/A' // Handle case when assessors are missing or not an array
//       },
//       {},

//       ...matchingBatches.map((student, index) => {
//         const participantDetails = sessionDetails.find(
//           participant => String(participant.custom_participant_id) === String(student.id)
//         );
//         return {
//           'S.no': index + 1,
//           'Display Name': student.name,
//           'Joined At': participantDetails ? formatDate(participantDetails.joined_at) : 'Absent',
//           'Left At': participantDetails ? formatDate(participantDetails.left_at) : 'N/A',
//           'Duration': participantDetails ? convertSecondsToMinutes(participantDetails.duration) + ' hrs' : 'N/A'
//         };
//       }),
//     ];

//     const worksheet = XLSX.utils.json_to_sheet(sheetData);

//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Session Details');

//     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//     const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//     const fileName = `${selectedSessionId ? selectedSessionId : 'batch'}_session_details.xlsx`;

//     // Create a download link and trigger the download
//     const link = document.createElement('a');
//     link.href = window.URL.createObjectURL(blob);
//     link.download = fileName;
//     link.click();
//   };




//   const renderSessionTable = () => {
//     let validRowIndex = 0; // Counter for valid rows

//     return (
//       <div className="container-responsive mt-4">
//         {matchingSessions.length >= 0 && (
//           <Table striped bordered hover responsive style={{ width: '100%', tableLayout: 'fixed' }}>
//             <TableHead>
//               <TableRow>
//                 <TableCell style={{ fontWeight: 'bold'}} >S.no</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Meeting Name</TableCell>
//                 {/* <TableCell>Total Participants</TableCell> */}
//                 <TableCell style={{ fontWeight: 'bold'}} >Minutes Consumed</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Starting At</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Ending At</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Action</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {currentSessions.map((session, index) => (
//                 // Check if total_participants is not 0
//                 session.total_participants !== 0 && (
//                   <TableRow key={session.id}>
//                     <TableCell>{++validRowIndex}</TableCell> {/* Increment validRowIndex for each valid row */}
//                     <TableCell>{session.meeting_display_name}</TableCell>
//                     {/* <TableCell>{session.total_participants}</TableCell> */}

//                     <TableCell>{convertSecondsToMinutes(session.minutes_consumed)} hrs</TableCell>
//                     <TableCell>{formatDate(session.started_at)}</TableCell>
//                     <TableCell>{formatDate(session.ended_at)}</TableCell>
//                     <TableCell>
//                       <Button variant='contained' color='primary'
//                         type='Submit' onClick={() => handleSessionButtonClick(session.id)}>
//                         View
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 )
//               ))}
//             </TableBody>
//           </Table>
//         )}
//         <TablePagination
//           component="div"
//           count={matchingSessions.filter(session => session.total_participants !== 0).length} // Adjust count based on valid rows
//           page={page}
//           onPageChange={handleChangePage}
//           rowsPerPage={rowsPerPage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </div>
//     );
//   };




//   const renderSessionDetailsTable = () => (
//     <div>
//       {sessionDetails && (
//         <Table aria-label="table" style={{ tableLayout: 'fixed', minWidth: '600px' }}>
//           <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
//             <TableRow>
//               <TableCell style={{ width: '100%' }}>S.no</TableCell>
//               <TableCell style={{ fontWeight: 'bold'}} >Meeting Name</TableCell>
//               <TableCell style={{ fontWeight: 'bold'}} >Joined At</TableCell>
//               <TableCell style={{ fontWeight: 'bold'}} >Left At</TableCell>
//               <TableCell style={{ fontWeight: 'bold'}} >Duration</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {sessionDetails.map((participant, index) => (
//               <TableRow key={participant.id}>
//                 <TableCell>{index + 1}</TableCell>
//                 <TableCell>{participant.display_name}</TableCell>
//                 <TableCell>{formatDate(participant.joined_at)}</TableCell>
//                 <TableCell>{formatDate(participant.left_at)}</TableCell>
//                 <TableCell>{convertSecondsToMinutes(participant.duration)} hrs</TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       )}
//     </div>
//   );



//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const response = await axios.get(`/registrationadvances/active/${intakeId1}`);
//         // const filteredBatches = response.data.filter(batch => batch.batch_id.toString() === batchId1);
//         const filteredBatches = response.data
//         setMatchingBatches(filteredBatches);
//         // console.log("hdghds"+filteredBatches);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       }
//     }
//     fetchData();
//   }, [batchId1]);

//   // const fetchExternalDataFromAPI11 = async () => {
//   //   try {
//   //     // const response1 = await axios.get(`registrationadvances/registration/active`);
//   //     const response1 = await axios.get(`/registrationadvances/active/${intakeId1}`);
//   //     const externalData = response1.data;

//   //     setExternalStudents(externalData);

//   //     externalData.forEach(item => {
//   //       if (item.scheduleDate) {
//   //         const startDateForModulus0 = item.scheduleDate.find(schedule => schedule.startModulus === 0)?.startDate;
//   //         const endDateForModulus5 = item.scheduleDate.find(schedule => schedule.startModulus === 5)?.endDate;

//   //         if (startDateForModulus0) {
//   //           console.log('Start Date for Modulus 0:', startDateForModulus0);
//   //         }
//   //         if (endDateForModulus5) {
//   //           console.log('End Date for Modulus 5:', endDateForModulus5);
//   //         }
//   //       }
//   //     });


//   //   } catch (error) {
//   //     console.error('Error fetching external data:', error);
//   //   }
//   // };

//   return (
//     <div>
//       {loading && <Loader />}
//       {!loading && (
//         <TableContainer sx={{ maxHeight: 'none' }}>
//           {renderSessionTable()}
//         </TableContainer>
//       )}

//       <Modal show={showModal} onHide={handleCloseModal} centered size="fullscreen">
//         <Modal.Header closeButton>
//           <Modal.Title style={{ fontSize: '30px' }}>Session Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {sessionDetails && (
//             <div>
//               <Table aria-label="sticky table" style={{ tableLayout: 'fixed', minWidth: '600px' }}>
//                 <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
//                   <TableRow>
//                     <TableCell style={{ width: '160px' , fontWeight: 'bold' }}>S.No</TableCell>
//                     <TableCell style={{ fontWeight: 'bold'}} >Name</TableCell>
//                     <TableCell style={{ fontWeight: 'bold'}} >Joined At</TableCell>
//                     <TableCell style={{ fontWeight: 'bold'}} >Left At</TableCell>
//                     <TableCell style={{ fontWeight: 'bold'}} >Duration</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>

//                   {matchingBatches.map((student, index) => {
//                     // console.log("old" + JSON.stringify(sessionDetails));
//                     const participantDetails = sessionDetails
//                       // .filter(participant =>) // Filter out "group_call_host"
//                       .find(participant => String(participant.custom_participant_id) === String(student.id) && participant.role == "group_call_participant");

//                     // const participantDetails = sessionDetails;
//                     // console.log("student" + JSON.stringify(student));
//                     // console.log("new" + JSON.stringify(participantDetails));
//                     return (
//                       <TableRow key={index}>
//                         <TableCell>{index + 1}</TableCell>
//                         <TableCell>{student.name}</TableCell>
//                         <TableCell>{participantDetails ? formatDate(participantDetails.joined_at) : 'Absent'}</TableCell>
//                         <TableCell>{participantDetails ? formatDate(participantDetails.left_at) : 'N/A'}</TableCell>
//                         <TableCell>{participantDetails ? convertSecondsToMinutes(participantDetails.duration) + ' hrs' : 'N/A'}</TableCell>
//                       </TableRow>
//                     );
//                   })}
//                 </TableBody>

//               </Table>
//             </div>
//           )}
//         </Modal.Body>

//         <Modal.Footer>

//           <button className='primary' onClick={handleCloseModal}
//             style={{
//               background: '#ff0000',
//               fontSize: '17px',
//               color: 'white',
//               border: 'none',
//               padding: '8px 40px',
//               borderRadius: '7px'
//             }}
//           >

//             Close
//           </button>
//           <button
//             className='primary'

//             startIcon={<SaveAltIcon />}
//             onClick={downloadSessionDetailsToExcel}
//             style={{
//               background: 'green',
//               fontSize: '17px',
//               color: 'white',
//               border: 'none',
//               padding: '8px 30px',
//               borderRadius: '7px'
//             }}
//           >
//             Download
//           </button>

//         </Modal.Footer>
//       </Modal>

//     </div>
//   );
// };

// export default BatchDetails;


// import React, { useEffect, useState } from 'react';
// import axios, { renderDoc, decryptData } from '../Axiosinstance';
// import { useParams } from 'react-router-dom';
// import {  Modal } from 'react-bootstrap';
// import Loader from '../Loader'
// import Paper from '@mui/material/Paper';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
// import TableRow from '@mui/material/TableRow';
// import * as XLSX from 'xlsx';
// import SaveAltIcon from '@mui/icons-material/SaveAlt';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { baseURLdyte, Password, Username } from '../common'
// import Button from '@mui/material/Button';

// const BatchDetails = () => {
//   const { batchId, intakeId } = useParams();
//   const batchId1 = decryptData(decodeURIComponent(batchId))
//   const intakeId1 = decryptData(decodeURIComponent(intakeId))
//   const [batchDetails, setBatchDetails] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [matchingSessions, setMatchingSessions] = useState([]);
//   const [selectedSessionId, setSelectedSessionId] = useState(null);
//   const [sessionDetails, setSessionDetails] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [matchingBatches, setMatchingBatches] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5); // Set the number of sessions per page
//   const [intakedata, setIntakedata] = useState([]);

//   // Calculate the indexes for the current page
//   const indexOfLastSession = (page + 1) * rowsPerPage;
//   const indexOfFirstSession = indexOfLastSession - rowsPerPage;
//   const currentSessions = matchingSessions.slice(indexOfFirstSession, indexOfLastSession);

//   // Function to handle page change
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   // Function to handle rows per page change
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   useEffect(() => {
//     const fetchBatchDetails = async () => {
//       try {
//         const response = await axios.get(`batch/${batchId1}`);
//         setBatchDetails(response.data);
//       } catch (error) {
//         console.error('Error fetching batch details:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBatchDetails();
//   }, [batchId1]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(`/intake-details/intake/${intakeId1}`);
//         if (response.data) {
//           setIntakedata(response.data);
//           setLoading(false);
//         } else {
//           throw new Error('Data format is incorrect');
//         }
//       } catch (error) {
//         console.error('Fetch error:', error);
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [intakeId1]);

//   useEffect(() => {
//     const fetchSessions = async () => {
//       try {
//         const orgId = Username;
//         const apiKey = Password;
//         const authHeader = `Basic ${btoa(`${orgId}:${apiKey}`)}`;

//         const sessionsResponse = await axios.get(`${baseURLdyte}/sessions`, {
//           headers: {
//             Authorization: authHeader,
//           },
//         });

//         const sessions = sessionsResponse.data.data.sessions;

//         if (batchDetails && sessions) {
//           const url = batchDetails.onlineclasslink
//           const match = url.match(/id=([a-f\d-]+)/i);

//           if (match && match[1]) {
//             const meetingId = match[1];

//             const matchingSessions = sessions.filter(
//               session => session.meta.room_name === meetingId
//             );

//             setMatchingSessions(matchingSessions);
//             console.log(matchingSessions)
//           } else {
//             console.warn('Meeting ID not found in onlineclasslink');
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching sessions:', error);
//       }
//     };

//     fetchSessions();
//   }, [batchDetails]);

//   const handleSessionButtonClick = async (sessionId) => {
//     setSelectedSessionId(sessionId);
//     setShowModal(true);

//     try {
//       const orgId = Username;
//       const apiKey = Password;
//       const authHeader = `Basic ${btoa(`${orgId}:${apiKey}`)}`;

//       const response = await axios.get(`${baseURLdyte}/sessions/${sessionId}/participants`, {
//         headers: {
//           Authorization: authHeader,
//         },
//       });

//       const participantsData = response.data.data.participants;
//       setSessionDetails(participantsData);
//       console.log("hello", JSON.stringify(participantsData))
//     } catch (error) {
//       console.error('Error fetching session details:', error);
//     }
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//   };

//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   const convertSecondsToMinutes = (seconds) => {
//     return (seconds / 60).toFixed(2); // Round to 2 decimal places
//   };

//   function formatToDDMMYYYY(dateString) {
//     if (!dateString) return 'Invalid Date'; // Handle undefined or null input

//     const date = new Date(dateString);

//     if (isNaN(date)) return 'Invalid Date'; // Handle invalid date strings

//     const day = String(date.getDate()).padStart(2, '0'); // Add leading zero
//     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
//     const year = date.getFullYear();

//     return `${day}/${month}/${year}`;
//   }


//   const downloadSessionDetailsToExcel = () => {
//     const workbook = XLSX.utils.book_new();

//     // Combine batch and session details into a single sheet
//     const sheetData = [

//       {
//         'Course': batchDetails.course || 'N/A', // Default to 'N/A' if course is missing
//         'Intake': intakeId1 || 'N/A', // Default to 'N/A' if intakeId1 is missing
//         'Trainers': Array.isArray(intakedata.trainers) && intakedata.trainers.length > 0
//           ? intakedata.trainers.join(', ')
//           : 'N/A', // Handle case when trainers are missing or not an array

//         'Course Start Date': intakedata.scheduleDateDetails?.[0]?.startDate
//           ? formatToDDMMYYYY(intakedata.scheduleDateDetails[0].startDate)
//           : 'N/A', // Check if startDate exists

//         'Course End Date': intakedata.scheduleDateDetails?.length > 0
//           ? formatToDDMMYYYY(intakedata.scheduleDateDetails[intakedata.scheduleDateDetails.length - 1].endDate)
//           : 'N/A', // Check if there are schedule details and get the last endDate

//         'Assessors': Array.isArray(intakedata.assessors) && intakedata.assessors.length > 0
//           ? intakedata.assessors.join(', ')
//           : 'N/A' // Handle case when assessors are missing or not an array
//       },
//       {},

//       ...matchingBatches.map((student, index) => {
//         const participantDetails = sessionDetails.find(
//           participant => String(participant.custom_participant_id) === String(student.id)
//         );
//         return {
//           'S.no': index + 1,
//           'Display Name': student.name,
//           'Joined At': participantDetails ? formatDate(participantDetails.joined_at) : 'Absent',
//           'Left At': participantDetails ? formatDate(participantDetails.left_at) : 'N/A',
//           'Duration': participantDetails ? convertSecondsToMinutes(participantDetails.duration) + ' hrs' : 'N/A'
//         };
//       }),
//     ];

//     const worksheet = XLSX.utils.json_to_sheet(sheetData);

//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Session Details');

//     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//     const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//     const fileName = `${selectedSessionId ? selectedSessionId : 'batch'}_session_details.xlsx`;

//     // Create a download link and trigger the download
//     const link = document.createElement('a');
//     link.href = window.URL.createObjectURL(blob);
//     link.download = fileName;
//     link.click();
//   };




//   const renderSessionTable = () => {
//     let validRowIndex = 0; // Counter for valid rows

//     return (
//       <div className="container-responsive mt-4">
//         {matchingSessions.length >= 0 && (
//           <Table striped bordered hover responsive style={{ width: '100%', tableLayout: 'fixed' }}>
//             <TableHead>
//               <TableRow>
//                 <TableCell style={{ fontWeight: 'bold'}} >S.no</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Meeting Name</TableCell>
//                 {/* <TableCell>Total Participants</TableCell> */}
//                 <TableCell style={{ fontWeight: 'bold'}} >Minutes Consumed</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Starting At</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Ending At</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Action</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {currentSessions.map((session, index) => (
//                 // Check if total_participants is not 0
//                 session.total_participants !== 0 && (
//                   <TableRow key={session.id}>
//                     <TableCell>{++validRowIndex}</TableCell> {/* Increment validRowIndex for each valid row */}
//                     <TableCell>{session.meeting_display_name}</TableCell>
//                     {/* <TableCell>{session.total_participants}</TableCell> */}

//                     <TableCell>{convertSecondsToMinutes(session.minutes_consumed)} hrs</TableCell>
//                     <TableCell>{formatDate(session.started_at)}</TableCell>
//                     <TableCell>{formatDate(session.ended_at)}</TableCell>
//                     <TableCell>
//                       <Button variant='contained' color='primary'
//                         type='Submit' onClick={() => handleSessionButtonClick(session.id)}>
//                         View
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 )
//               ))}
//             </TableBody>
//           </Table>
//         )}
//         <TablePagination
//           component="div"
//           count={matchingSessions.filter(session => session.total_participants !== 0).length} // Adjust count based on valid rows
//           page={page}
//           onPageChange={handleChangePage}
//           rowsPerPage={rowsPerPage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </div>
//     );
//   };




//   const renderSessionDetailsTable = () => (
//     <div>
//       {sessionDetails && (
//         <Table aria-label="table" style={{ tableLayout: 'fixed', minWidth: '600px' }}>
//           <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
//             <TableRow>
//               <TableCell style={{ width: '100%' }}>S.no</TableCell>
//               <TableCell style={{ fontWeight: 'bold'}} >Meeting Name</TableCell>
//               <TableCell style={{ fontWeight: 'bold'}} >Joined At</TableCell>
//               <TableCell style={{ fontWeight: 'bold'}} >Left At</TableCell>
//               <TableCell style={{ fontWeight: 'bold'}} >Duration</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {sessionDetails.map((participant, index) => (
//               <TableRow key={participant.id}>
//                 <TableCell>{index + 1}</TableCell>
//                 <TableCell>{participant.display_name}</TableCell>
//                 <TableCell>{formatDate(participant.joined_at)}</TableCell>
//                 <TableCell>{formatDate(participant.left_at)}</TableCell>
//                 <TableCell>{convertSecondsToMinutes(participant.duration)} hrs</TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       )}
//     </div>
//   );



//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const response = await axios.get(`/registrationadvances/active/${intakeId1}`);
//         // const filteredBatches = response.data.filter(batch => batch.batch_id.toString() === batchId1);
//         const filteredBatches = response.data
//         setMatchingBatches(filteredBatches);
//         // console.log("hdghds"+filteredBatches);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       }
//     }
//     fetchData();
//   }, [batchId1]);

//   // const fetchExternalDataFromAPI11 = async () => {
//   //   try {
//   //     // const response1 = await axios.get(`registrationadvances/registration/active`);
//   //     const response1 = await axios.get(`/registrationadvances/active/${intakeId1}`);
//   //     const externalData = response1.data;

//   //     setExternalStudents(externalData);

//   //     externalData.forEach(item => {
//   //       if (item.scheduleDate) {
//   //         const startDateForModulus0 = item.scheduleDate.find(schedule => schedule.startModulus === 0)?.startDate;
//   //         const endDateForModulus5 = item.scheduleDate.find(schedule => schedule.startModulus === 5)?.endDate;

//   //         if (startDateForModulus0) {
//   //           console.log('Start Date for Modulus 0:', startDateForModulus0);
//   //         }
//   //         if (endDateForModulus5) {
//   //           console.log('End Date for Modulus 5:', endDateForModulus5);
//   //         }
//   //       }
//   //     });


//   //   } catch (error) {
//   //     console.error('Error fetching external data:', error);
//   //   }
//   // };

//   return (
//     <div>
//       {loading && <Loader />}
//       {!loading && (
//         <TableContainer sx={{ maxHeight: 'none' }}>
//           {renderSessionTable()}
//         </TableContainer>
//       )}

//       <Modal show={showModal} onHide={handleCloseModal} centered size="fullscreen">
//         <Modal.Header closeButton>
//           <Modal.Title style={{ fontSize: '30px' }}>Session Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {sessionDetails && (
//             <div>
//               <Table aria-label="sticky table" style={{ tableLayout: 'fixed', minWidth: '600px' }}>
//                 <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
//                   <TableRow>
//                     <TableCell style={{ width: '160px' , fontWeight: 'bold' }}>S.No</TableCell>
//                     <TableCell style={{ fontWeight: 'bold'}} >Name</TableCell>
//                     <TableCell style={{ fontWeight: 'bold'}} >Joined At</TableCell>
//                     <TableCell style={{ fontWeight: 'bold'}} >Left At</TableCell>
//                     <TableCell style={{ fontWeight: 'bold'}} >Duration</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>

//                   {matchingBatches.map((student, index) => {
//                     // console.log("old" + JSON.stringify(sessionDetails));
//                     const participantDetails = sessionDetails
//                       // .filter(participant =>) // Filter out "group_call_host"
//                       .find(participant => String(participant.custom_participant_id) === String(student.id) && participant.role == "group_call_participant");

//                     // const participantDetails = sessionDetails;
//                     // console.log("student" + JSON.stringify(student));
//                     // console.log("new" + JSON.stringify(participantDetails));
//                     return (
//                       <TableRow key={index}>
//                         <TableCell>{index + 1}</TableCell>
//                         <TableCell>{student.name}</TableCell>
//                         <TableCell>{participantDetails ? formatDate(participantDetails.joined_at) : 'Absent'}</TableCell>
//                         <TableCell>{participantDetails ? formatDate(participantDetails.left_at) : 'N/A'}</TableCell>
//                         <TableCell>{participantDetails ? convertSecondsToMinutes(participantDetails.duration) + ' hrs' : 'N/A'}</TableCell>
//                       </TableRow>
//                     );
//                   })}
//                 </TableBody>

//               </Table>
//             </div>
//           )}
//         </Modal.Body>

//         <Modal.Footer>

//           <button className='primary' onClick={handleCloseModal}
//             style={{
//               background: '#ff0000',
//               fontSize: '17px',
//               color: 'white',
//               border: 'none',
//               padding: '8px 40px',
//               borderRadius: '7px'
//             }}
//           >

//             Close
//           </button>
//           <button
//             className='primary'

//             startIcon={<SaveAltIcon />}
//             onClick={downloadSessionDetailsToExcel}
//             style={{
//               background: 'green',
//               fontSize: '17px',
//               color: 'white',
//               border: 'none',
//               padding: '8px 30px',
//               borderRadius: '7px'
//             }}
//           >
//             Download
//           </button>

//         </Modal.Footer>
//       </Modal>

//     </div>
//   );
// };

// export default BatchDetails;


// import React, { useEffect, useState } from 'react';
// import axios, { renderDoc, decryptData } from '../Axiosinstance';
// import { useParams } from 'react-router-dom';
// import { Modal } from 'react-bootstrap';
// import Loader from '../Loader'
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
// import TableRow from '@mui/material/TableRow';
// import * as XLSX from 'xlsx';
// import SaveAltIcon from '@mui/icons-material/SaveAlt';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { baseURLdyte, Password, Username } from '../common'
// import Button from '@mui/material/Button';

// const BatchDetails = () => {
//   const { batchId, intakeId } = useParams();
//   const batchId1 = decryptData(decodeURIComponent(batchId))
//   const intakeId1 = decryptData(decodeURIComponent(intakeId))

//   const [batchDetails, setBatchDetails] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [matchingSessions, setMatchingSessions] = useState([]);
//   const [selectedSessionId, setSelectedSessionId] = useState(null);
//   const [sessionDetails, setSessionDetails] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [matchingBatches, setMatchingBatches] = useState([]);
//   const [attendanceSaved, setAttendanceSaved] = useState(false); // ✅ NEW

//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [intakedata, setIntakedata] = useState([]);

//   const indexOfLastSession = (page + 1) * rowsPerPage;
//   const indexOfFirstSession = indexOfLastSession - rowsPerPage;
//   const currentSessions = matchingSessions.slice(indexOfFirstSession, indexOfLastSession);

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // ---------------- FETCH DATA ----------------

//   useEffect(() => {
//     axios.get(`batch/${batchId1}`)
//       .then(res => setBatchDetails(res.data))
//       .catch(err => console.error(err))
//       .finally(() => setLoading(false));
//   }, [batchId1]);

//   useEffect(() => {
//     axios.get(`/intake-details/intake/${intakeId1}`)
//       .then(res => setIntakedata(res.data))
//       .catch(err => console.error(err));
//   }, [intakeId1]);

//   useEffect(() => {
//     const fetchSessions = async () => {
//       const authHeader = `Basic ${btoa(`${Username}:${Password}`)}`;

//       const res = await axios.get(`${baseURLdyte}/sessions`, {
//         headers: { Authorization: authHeader }
//       });

//       const sessions = res.data.data.sessions;

//       if (batchDetails) {
//         const match = batchDetails.onlineclasslink.match(/id=([a-f\d-]+)/i);
//         const meetingId = match?.[1];

//         setMatchingSessions(
//           sessions.filter(s => s.meta.room_name === meetingId)
//         );
//       }
//     };

//     fetchSessions();
//   }, [batchDetails]);

//   const handleSessionButtonClick = async (sessionId) => {
//     setSelectedSessionId(sessionId);
//     setShowModal(true);
//     setAttendanceSaved(false); // reset

//     const authHeader = `Basic ${btoa(`${Username}:${Password}`)}`;

//     const res = await axios.get(`${baseURLdyte}/sessions/${sessionId}/participants`, {
//       headers: { Authorization: authHeader }
//     });

//     setSessionDetails(res.data.data.participants);
//   };

//   // ---------------- SAVE ATTENDANCE ----------------

//   const saveAttendanceToBackend = async () => {
//     if (!sessionDetails || !matchingBatches.length) {
//       alert("No data");
//       return;
//     }

//     const meetingId = batchDetails?.onlineclasslink?.match(/id=([a-f\d-]+)/i)?.[1];

//     const participants = matchingBatches.map(student => {
//       const p = sessionDetails.find(
//         x => String(x.custom_participant_id) === String(student.id)
//         && x.role === "group_call_participant"
//       );

//       return {
//         studentId: student.id,
//         studentName: student.name,
//         joinedAt: p?.joined_at || null,
//         leftAt: p?.left_at || null,
//         durationSeconds: p?.duration || null,
//         present: !!p
//       };
//     });

//     const payload = {
//       sessionId: selectedSessionId,
//       meetingId,
//       intakeId: intakeId1,
//       batchId: parseInt(batchId1),
//       participants
//     };

//     try {
//       await axios.post('/online-meeting/meeting-attendance/save', payload);
//       setAttendanceSaved(true);
//       alert("✅ Saved");
//     } catch (e) {
//       console.error(e);
//       alert("❌ Error");
//     }
//   };

//   // ---------------- UTIL ----------------

//   const formatDate = d => new Date(d).toLocaleString();
//   const convertSecondsToMinutes = s => (s / 60).toFixed(2);

//   useEffect(() => {
//     axios.get(`/registrationadvances/active/${intakeId1}`)
//       .then(res => setMatchingBatches(res.data));
//   }, [batchId1]);

//   // ---------------- UI ----------------

//   return (
//     <div>
//       {loading && <Loader />}

//       <TableContainer>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>S.no</TableCell>
//               <TableCell>Meeting</TableCell>
//               <TableCell>Minutes</TableCell>
//               <TableCell>Start</TableCell>
//               <TableCell>End</TableCell>
//               <TableCell>Action</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {currentSessions.map((s, i) => (
//               <TableRow key={s.id}>
//                 <TableCell>{i + 1}</TableCell>
//                 <TableCell>{s.meeting_display_name}</TableCell>
//                 <TableCell>{convertSecondsToMinutes(s.minutes_consumed)}</TableCell>
//                 <TableCell>{formatDate(s.started_at)}</TableCell>
//                 <TableCell>{formatDate(s.ended_at)}</TableCell>
//                 <TableCell>
//                   <Button onClick={() => handleSessionButtonClick(s.id)}>
//                     View
//                   </Button>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Modal show={showModal} onHide={() => setShowModal(false)} size="fullscreen">
//         <Modal.Header closeButton>
//           <Modal.Title>Session Details</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {matchingBatches.map((student, i) => {
//             const p = sessionDetails?.find(
//               x => String(x.custom_participant_id) === String(student.id)
//             );

//             return (
//               <div key={i}>
//                 {student.name} → {p ? "Present" : "Absent"}
//               </div>
//             );
//           })}
//         </Modal.Body>

//         <Modal.Footer>

//           <button onClick={() => setShowModal(false)}>Close</button>

//           {/* ✅ SAVE BUTTON */}
//           <button
//             onClick={saveAttendanceToBackend}
//             disabled={attendanceSaved}
//             style={{ background: attendanceSaved ? "gray" : "orange" }}
//           >
//             {attendanceSaved ? "Saved ✓" : "Save Attendance"}
//           </button>

//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default BatchDetails;



// import React, { useEffect, useState } from 'react';
// import axios, { decryptData } from '../Axiosinstance';
// import { useParams } from 'react-router-dom';
// import { Modal } from 'react-bootstrap';
// import Loader from '../Loader'
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
// import TableRow from '@mui/material/TableRow';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { baseURLdyte, Password, Username } from '../common'
// import Button from '@mui/material/Button';

// const BatchDetails = () => {

//   const { batchId, intakeId } = useParams();
//   const batchId1 = decryptData(decodeURIComponent(batchId));
//   const intakeId1 = decryptData(decodeURIComponent(intakeId));

//   const [batchDetails, setBatchDetails] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [matchingSessions, setMatchingSessions] = useState([]);
//   const [selectedSessionId, setSelectedSessionId] = useState(null);
//   const [sessionDetails, setSessionDetails] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [matchingBatches, setMatchingBatches] = useState([]);
//   const [attendanceSaved, setAttendanceSaved] = useState(false); // ✅ IMPORTANT

//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   // ---------------- FETCH BATCH ----------------
//   useEffect(() => {
//     axios.get(`batch/${batchId1}`)
//       .then(res => setBatchDetails(res.data))
//       .catch(err => console.error(err))
//       .finally(() => setLoading(false));
//   }, [batchId1]);

//   // ---------------- FETCH STUDENTS ----------------
//   useEffect(() => {
//     axios.get(`/registrationadvances/active/${intakeId1}`)
//       .then(res => setMatchingBatches(res.data))
//       .catch(err => console.error(err));
//   }, [intakeId1]);

//   // ---------------- FETCH SESSIONS ----------------
//   useEffect(() => {
//     const fetchSessions = async () => {
//       try {
//         const authHeader = `Basic ${btoa(`${Username}:${Password}`)}`;

//         const res = await axios.get(`${baseURLdyte}/sessions`, {
//           headers: { Authorization: authHeader }
//         });

//         const sessions = res.data.data.sessions;

//         if (batchDetails) {
//           const meetingId = batchDetails.onlineclasslink?.match(/id=([a-f\d-]+)/i)?.[1];

//           const filtered = sessions.filter(
//             s => s.meta.room_name === meetingId
//           );

//           setMatchingSessions(filtered);
//         }
//       } catch (err) {
//         console.error("Error fetching sessions", err);
//       }
//     };

//     fetchSessions();
//   }, [batchDetails]);

//   // ---------------- CLICK SESSION ----------------
//   const handleSessionButtonClick = async (sessionId) => {
//     setSelectedSessionId(sessionId);
//     setShowModal(true);
//     setAttendanceSaved(false); // reset

//     try {
//       const authHeader = `Basic ${btoa(`${Username}:${Password}`)}`;

//       const res = await axios.get(
//         `${baseURLdyte}/sessions/${sessionId}/participants`,
//         { headers: { Authorization: authHeader } }
//       );

//       setSessionDetails(res.data.data.participants);

//     } catch (err) {
//       console.error("Error fetching participants", err);
//     }
//   };

//   // ---------------- SAVE ATTENDANCE ----------------
//   const saveAttendanceToBackend = async () => {

//     if (!sessionDetails || !matchingBatches.length) return;

//     const meetingId = batchDetails?.onlineclasslink?.match(/id=([a-f\d-]+)/i)?.[1];

//     const participants = matchingBatches.map(student => {
//       const p = sessionDetails.find(
//         x => String(x.custom_participant_id) === String(student.id)
//         && x.role === "group_call_participant"
//       );

//       return {
//         studentId: student.id,
//         studentName: student.name,
//         joinedAt: p?.joined_at || null,
//         leftAt: p?.left_at || null,
//         durationSeconds: p?.duration || null,
//         present: !!p
//       };
//     });

//     const payload = {
//       sessionId: selectedSessionId,
//       meetingId,
//       intakeId: intakeId1,
//       batchId: parseInt(batchId1),
//       participants
//     };

//     try {
//       await axios.post('/online-meeting/meeting-attendance/save', payload);
//       console.log("✅ Attendance auto-saved");
//       setAttendanceSaved(true);
//     } catch (err) {
//       console.error("❌ Save failed", err);
//     }
//   };

//   // ---------------- AUTO SAVE (🔥 MAIN CHANGE) ----------------
//   useEffect(() => {
//     if (sessionDetails && matchingBatches.length > 0 && !attendanceSaved) {
//       console.log("🔥 Auto saving attendance...");
//       saveAttendanceToBackend();
//     }
//   }, [sessionDetails]); // ONLY trigger when session loads

//   // ---------------- UI HELPERS ----------------
//   const formatDate = d => new Date(d).toLocaleString();
//   const convertSecondsToMinutes = s => (s / 60).toFixed(2);

//   const indexOfLast = (page + 1) * rowsPerPage;
//   const indexOfFirst = indexOfLast - rowsPerPage;
//   const currentSessions = matchingSessions.slice(indexOfFirst, indexOfLast);

//   // ---------------- UI ----------------
//   return (
//     <div>

//       {loading && <Loader />}

//       <TableContainer>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>S.no</TableCell>
//               <TableCell>Meeting</TableCell>
//               <TableCell>Minutes</TableCell>
//               <TableCell>Start</TableCell>
//               <TableCell>End</TableCell>
//               <TableCell>Action</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {currentSessions.map((s, i) => (
//               <TableRow key={s.id}>
//                 <TableCell>{i + 1}</TableCell>
//                 <TableCell>{s.meeting_display_name}</TableCell>
//                 <TableCell>{convertSecondsToMinutes(s.minutes_consumed)}</TableCell>
//                 <TableCell>{formatDate(s.started_at)}</TableCell>
//                 <TableCell>{formatDate(s.ended_at)}</TableCell>
//                 <TableCell>
//                   <Button onClick={() => handleSessionButtonClick(s.id)}>
//                     View
//                   </Button>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Modal show={showModal} onHide={() => setShowModal(false)} size="fullscreen">
//         <Modal.Header closeButton>
//           <Modal.Title>Session Details</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {matchingBatches.map((student, i) => {
//             const p = sessionDetails?.find(
//               x => String(x.custom_participant_id) === String(student.id)
//             );

//             return (
//               <div key={i}>
//                 {student.name} → {p ? "Present" : "Absent"}
//               </div>
//             );
//           })}
//         </Modal.Body>

//         <Modal.Footer>
//           <button onClick={() => setShowModal(false)}>Close</button>
//         </Modal.Footer>
//       </Modal>

//     </div>
//   );
// };

// export default BatchDetails;



// import React, { useEffect, useState } from 'react';
// import axios, { renderDoc, decryptData } from '../Axiosinstance';
// import { useParams } from 'react-router-dom';
// import { Modal } from 'react-bootstrap';
// import Loader from '../Loader'
// import Paper from '@mui/material/Paper';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
// import TableRow from '@mui/material/TableRow';
// import * as XLSX from 'xlsx';
// import SaveAltIcon from '@mui/icons-material/SaveAlt';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { baseURLdyte, Password, Username } from '../common'
// import Button from '@mui/material/Button';

// const BatchDetails = () => {
//   const { batchId, intakeId } = useParams();
//   const batchId1 = decryptData(decodeURIComponent(batchId))
//   const intakeId1 = decryptData(decodeURIComponent(intakeId))
//   const [batchDetails, setBatchDetails] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [matchingSessions, setMatchingSessions] = useState([]);
//   const [selectedSessionId, setSelectedSessionId] = useState(null);
//   const [sessionDetails, setSessionDetails] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [matchingBatches, setMatchingBatches] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [intakedata, setIntakedata] = useState([]);

//   // ─── NEW STATE FOR ATTENDANCE ───────────────────────────────────────────────
//   const [attendanceSaved, setAttendanceSaved] = useState(false);
//   const [attendanceSaving, setAttendanceSaving] = useState(false);
//   const [savedSessionIds, setSavedSessionIds] = useState(new Set()); // track which sessions are already saved
//   // ────────────────────────────────────────────────────────────────────────────

//   // Calculate the indexes for the current page
//   const indexOfLastSession = (page + 1) * rowsPerPage;
//   const indexOfFirstSession = indexOfLastSession - rowsPerPage;
//   const currentSessions = matchingSessions.slice(indexOfFirstSession, indexOfLastSession);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   useEffect(() => {
//     const fetchBatchDetails = async () => {
//       try {
//         const response = await axios.get(`batch/${batchId1}`);
//         setBatchDetails(response.data);
//       } catch (error) {
//         console.error('Error fetching batch details:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchBatchDetails();
//   }, [batchId1]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(`/intake-details/intake/${intakeId1}`);
//         if (response.data) {
//           setIntakedata(response.data);
//           setLoading(false);
//         } else {
//           throw new Error('Data format is incorrect');
//         }
//       } catch (error) {
//         console.error('Fetch error:', error);
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [intakeId1]);

//   useEffect(() => {
//     const fetchSessions = async () => {
//       try {
//         const orgId = Username;
//         const apiKey = Password;
//         const authHeader = `Basic ${btoa(`${orgId}:${apiKey}`)}`;

//         const sessionsResponse = await axios.get(`${baseURLdyte}/sessions`, {
//           headers: { Authorization: authHeader },
//         });

//         const sessions = sessionsResponse.data.data.sessions;

//         if (batchDetails && sessions) {
//           const url = batchDetails.onlineclasslink;
//           const match = url.match(/id=([a-f\d-]+)/i);

//           if (match && match[1]) {
//             const meetingId = match[1];
//             const matchingSessions = sessions.filter(
//               session => session.meta.room_name === meetingId
//             );
//             setMatchingSessions(matchingSessions);
//           } else {
//             console.warn('Meeting ID not found in onlineclasslink');
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching sessions:', error);
//       }
//     };
//     fetchSessions();
//   }, [batchDetails]);

//   // ─── NEW: Check which sessions already have saved attendance ────────────────
//   useEffect(() => {
//     const checkSavedAttendance = async () => {
//       if (matchingSessions.length === 0) return;

//       try {
//         const response = await axios.get(
//           `/online-meeting/meeting-attendance/${batchId1}/${intakeId1}`
//         );
//         const savedRecords = response.data;

//         // Collect all sessionIds that already have attendance saved
//         const savedIds = new Set(savedRecords.map(record => record.sessionId));
//         setSavedSessionIds(savedIds);
//       } catch (error) {
//         console.error('Error checking saved attendance:', error);
//       }
//     };
//     checkSavedAttendance();
//   }, [matchingSessions, batchId1, intakeId1]);
//   // ────────────────────────────────────────────────────────────────────────────

//   const handleSessionButtonClick = async (sessionId) => {
//     setSelectedSessionId(sessionId);
//     setShowModal(true);

//     // ─── NEW: Reset attendance saved state when opening a new session ────────
//     setAttendanceSaved(savedSessionIds.has(sessionId)); // pre-set if already saved
//     // ─────────────────────────────────────────────────────────────────────────

//     try {
//       const orgId = Username;
//       const apiKey = Password;
//       const authHeader = `Basic ${btoa(`${orgId}:${apiKey}`)}`;

//       const response = await axios.get(`${baseURLdyte}/sessions/${sessionId}/participants`, {
//         headers: { Authorization: authHeader },
//       });

//       const participantsData = response.data.data.participants;
//       setSessionDetails(participantsData);
//     } catch (error) {
//       console.error('Error fetching session details:', error);
//     }
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setAttendanceSaved(false); // reset on close
//   };

//   // ─── NEW: Save Attendance Function ──────────────────────────────────────────
//   const saveAttendanceToBackend = async () => {
//     if (!sessionDetails || !matchingBatches.length) {
//       alert('No session data available to save.');
//       return;
//     }

//     setAttendanceSaving(true);

//     try {
//       // Extract meetingId from the batch's onlineclasslink
//       const meetingIdMatch = batchDetails?.onlineclasslink?.match(/id=([a-f\d-]+)/i);
//       const meetingId = meetingIdMatch ? meetingIdMatch[1] : null;

//       // Build participant records — match each enrolled student with Dyte session data
//       const participants = matchingBatches.map(student => {
//         const participantDetails = sessionDetails.find(
//           p =>
//             String(p.custom_participant_id) === String(student.id) &&
//             p.role === 'group_call_participant'
//         );

//         return {
//           studentId: student.student?.id || student.id,
//           studentName: student.name,
//           joinedAt: participantDetails?.joined_at || null,
//           leftAt: participantDetails?.left_at || null,
//           durationSeconds: participantDetails?.duration || null,
//           present: !!participantDetails,
//         };
//       });

//       const payload = {
//         sessionId: selectedSessionId,
//         meetingId: meetingId,
//         intakeId: intakeId1,
//         batchId: parseInt(batchId1),
//         participants,
//       };

//       const response = await axios.post(
//         '/online-meeting/meeting-attendance/save',
//         payload
//       );

//       // Mark this session as saved
//       setAttendanceSaved(true);
//       setSavedSessionIds(prev => new Set([...prev, selectedSessionId]));
//       alert(response.data || 'Attendance saved successfully!');
//     } catch (error) {
//       console.error('Error saving attendance:', error);
//       alert('Failed to save attendance. Please try again.');
//     } finally {
//       setAttendanceSaving(false);
//     }
//   };
//   // ────────────────────────────────────────────────────────────────────────────

//   const formatDate = (dateString) => {
//     const options = {
//       year: 'numeric', month: 'long', day: 'numeric',
//       hour: 'numeric', minute: 'numeric', second: 'numeric'
//     };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   const convertSecondsToMinutes = (seconds) => {
//     return (seconds / 60).toFixed(2);
//   };

//   function formatToDDMMYYYY(dateString) {
//     if (!dateString) return 'Invalid Date';
//     const date = new Date(dateString);
//     if (isNaN(date)) return 'Invalid Date';
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
//   }

//   const downloadSessionDetailsToExcel = () => {
//     const workbook = XLSX.utils.book_new();

//     const sheetData = [
//       {
//         'Course': batchDetails.course || 'N/A',
//         'Intake': intakeId1 || 'N/A',
//         'Trainers': Array.isArray(intakedata.trainers) && intakedata.trainers.length > 0
//           ? intakedata.trainers.join(', ') : 'N/A',
//         'Course Start Date': intakedata.scheduleDateDetails?.[0]?.startDate
//           ? formatToDDMMYYYY(intakedata.scheduleDateDetails[0].startDate) : 'N/A',
//         'Course End Date': intakedata.scheduleDateDetails?.length > 0
//           ? formatToDDMMYYYY(intakedata.scheduleDateDetails[intakedata.scheduleDateDetails.length - 1].endDate) : 'N/A',
//         'Assessors': Array.isArray(intakedata.assessors) && intakedata.assessors.length > 0
//           ? intakedata.assessors.join(', ') : 'N/A'
//       },
//       {},
//       ...matchingBatches.map((student, index) => {
//         const participantDetails = sessionDetails.find(
//           participant => String(participant.custom_participant_id) === String(student.id)
//         );
//         return {
//           'S.no': index + 1,
//           'Display Name': student.name,
//           'Joined At': participantDetails ? formatDate(participantDetails.joined_at) : 'Absent',
//           'Left At': participantDetails ? formatDate(participantDetails.left_at) : 'N/A',
//           'Duration': participantDetails ? convertSecondsToMinutes(participantDetails.duration) + ' hrs' : 'N/A'
//         };
//       }),
//     ];

//     const worksheet = XLSX.utils.json_to_sheet(sheetData);
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Session Details');
//     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//     const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//     const fileName = `${selectedSessionId ? selectedSessionId : 'batch'}_session_details.xlsx`;
//     const link = document.createElement('a');
//     link.href = window.URL.createObjectURL(blob);
//     link.download = fileName;
//     link.click();
//   };

//   const renderSessionTable = () => {
//     let validRowIndex = 0;

//     return (
//       <div className="container-responsive mt-4">
//         {matchingSessions.length >= 0 && (
//           <Table striped bordered hover responsive style={{ width: '100%', tableLayout: 'fixed' }}>
//             <TableHead>
//               <TableRow>
//                 <TableCell style={{ fontWeight: 'bold' }}>S.no</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Meeting Name</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Minutes Consumed</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Starting At</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Ending At</TableCell>
//                 {/* ─── NEW: Attendance Status Column ─── */}
//                 <TableCell style={{ fontWeight: 'bold' }}>Attendance</TableCell>
//                 {/* ──────────────────────────────────── */}
//                 <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {currentSessions.map((session, index) => (
//                 session.total_participants !== 0 && (
//                   <TableRow key={session.id}>
//                     <TableCell>{++validRowIndex}</TableCell>
//                     <TableCell>{session.meeting_display_name}</TableCell>
//                     <TableCell>{convertSecondsToMinutes(session.minutes_consumed)} hrs</TableCell>
//                     <TableCell>{formatDate(session.started_at)}</TableCell>
//                     <TableCell>{formatDate(session.ended_at)}</TableCell>

//                     {/* ─── NEW: Show saved badge per row ─── */}
//                     <TableCell>
//                       {savedSessionIds.has(session.id) ? (
//                         <span style={{
//                           backgroundColor: '#28a745',
//                           color: 'white',
//                           padding: '4px 10px',
//                           borderRadius: '12px',
//                           fontSize: '12px',
//                           fontWeight: 'bold'
//                         }}>
//                           ✓ Saved
//                         </span>
//                       ) : (
//                         <span style={{
//                           backgroundColor: '#ffc107',
//                           color: 'black',
//                           padding: '4px 10px',
//                           borderRadius: '12px',
//                           fontSize: '12px',
//                           fontWeight: 'bold'
//                         }}>
//                           Not Saved
//                         </span>
//                       )}
//                     </TableCell>
//                     {/* ─────────────────────────────────── */}

//                     <TableCell>
//                       <Button
//                         variant='contained'
//                         color='primary'
//                         type='Submit'
//                         onClick={() => handleSessionButtonClick(session.id)}
//                       >
//                         View
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 )
//               ))}
//             </TableBody>
//           </Table>
//         )}
//         <TablePagination
//           component="div"
//           count={matchingSessions.filter(session => session.total_participants !== 0).length}
//           page={page}
//           onPageChange={handleChangePage}
//           rowsPerPage={rowsPerPage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </div>
//     );
//   };

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const response = await axios.get(`/registrationadvances/active/${intakeId1}`);
//         const filteredBatches = response.data;
//         setMatchingBatches(filteredBatches);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       }
//     }
//     fetchData();
//   }, [batchId1]);

//   return (
//     <div>
//       {loading && <Loader />}
//       {!loading && (
//         <TableContainer sx={{ maxHeight: 'none' }}>
//           {renderSessionTable()}
//         </TableContainer>
//       )}

//       <Modal show={showModal} onHide={handleCloseModal} centered size="fullscreen">
//         <Modal.Header closeButton>
//           <Modal.Title style={{ fontSize: '30px' }}>Session Details</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {sessionDetails && (
//             <div>
//               <Table aria-label="sticky table" style={{ tableLayout: 'fixed', minWidth: '600px' }}>
//                 <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
//                   <TableRow>
//                     <TableCell style={{ width: '160px', fontWeight: 'bold' }}>S.No</TableCell>
//                     <TableCell style={{ fontWeight: 'bold' }}>Name</TableCell>
//                     <TableCell style={{ fontWeight: 'bold' }}>Joined At</TableCell>
//                     <TableCell style={{ fontWeight: 'bold' }}>Left At</TableCell>
//                     <TableCell style={{ fontWeight: 'bold' }}>Duration</TableCell>
//                     {/* ─── NEW: Status Column in Modal ─── */}
//                     <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
//                     {/* ─────────────────────────────────── */}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {matchingBatches.map((student, index) => {
//                     const participantDetails = sessionDetails.find(
//                       participant =>
//                         String(participant.custom_participant_id) === String(student.id) &&
//                         participant.role === 'group_call_participant'
//                     );

//                     return (
//                       <TableRow key={index}>
//                         <TableCell>{index + 1}</TableCell>
//                         <TableCell>{student.name}</TableCell>
//                         <TableCell>
//                           {participantDetails ? formatDate(participantDetails.joined_at) : 'Absent'}
//                         </TableCell>
//                         <TableCell>
//                           {participantDetails ? formatDate(participantDetails.left_at) : 'N/A'}
//                         </TableCell>
//                         <TableCell>
//                           {participantDetails
//                             ? convertSecondsToMinutes(participantDetails.duration) + ' hrs'
//                             : 'N/A'}
//                         </TableCell>
//                         {/* ─── NEW: Present/Absent badge ─── */}
//                         <TableCell>
//                           {participantDetails ? (
//                             <span style={{
//                               backgroundColor: '#28a745',
//                               color: 'white',
//                               padding: '4px 10px',
//                               borderRadius: '12px',
//                               fontSize: '12px',
//                               fontWeight: 'bold'
//                             }}>
//                               Present
//                             </span>
//                           ) : (
//                             <span style={{
//                               backgroundColor: '#dc3545',
//                               color: 'white',
//                               padding: '4px 10px',
//                               borderRadius: '12px',
//                               fontSize: '12px',
//                               fontWeight: 'bold'
//                             }}>
//                               Absent
//                             </span>
//                           )}
//                         </TableCell>
//                         {/* ─────────────────────────────── */}
//                       </TableRow>
//                     );
//                   })}
//                 </TableBody>
//               </Table>
//             </div>
//           )}
//         </Modal.Body>

//         <Modal.Footer>
//           <button
//             onClick={handleCloseModal}
//             style={{
//               background: '#ff0000',
//               fontSize: '17px',
//               color: 'white',
//               border: 'none',
//               padding: '8px 40px',
//               borderRadius: '7px'
//             }}
//           >
//             Close
//           </button>

//           {/* ─── NEW: Save Attendance Button ──────────────────────────────────── */}
//           <button
//             onClick={saveAttendanceToBackend}
//             disabled={attendanceSaved || attendanceSaving}
//             style={{
//               background: attendanceSaved ? '#6c757d' : attendanceSaving ? '#aaa' : '#FF8C00',
//               fontSize: '17px',
//               color: 'white',
//               border: 'none',
//               padding: '8px 30px',
//               borderRadius: '7px',
//               cursor: attendanceSaved || attendanceSaving ? 'not-allowed' : 'pointer',
//             }}
//           >
//             {attendanceSaving
//               ? 'Saving...'
//               : attendanceSaved
//               ? '✓ Attendance Saved'
//               : 'Save Attendance'}
//           </button>
//           {/* ─────────────────────────────────────────────────────────────────── */}

//           <button
//             className='primary'
//             startIcon={<SaveAltIcon />}
//             onClick={downloadSessionDetailsToExcel}
//             style={{
//               background: 'green',
//               fontSize: '17px',
//               color: 'white',
//               border: 'none',
//               padding: '8px 30px',
//               borderRadius: '7px'
//             }}
//           >
//             Download
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default BatchDetails;





import React, { useEffect, useState } from 'react';
import axios, { renderDoc, decryptData } from '../Axiosinstance';
import { useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Loader from '../Loader';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import * as XLSX from 'xlsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import { baseURLdyte, Password, Username } from '../common';
import Button from '@mui/material/Button';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

// ─── Colour palette (used in both UI badges and Excel fills) ─────────────────
const COLORS = {
  headerBg:     '1A3C6E',   // deep navy  (Excel hex, no #)
  headerText:   'FFFFFF',
  presentBg:    'D4EDDA',
  presentText:  '155724',
  absentBg:     'F8D7DA',
  absentText:   '721C24',
  summaryBlue:  'DBEAFE',
  summaryGreen: 'DCFCE7',
  summaryRed:   'FFE4E6',
  summaryAmber: 'FEF9C3',
  rowAlt:       'F0F4FF',
  accent:       '1A3C6E',
};

// ─── Tiny helper: CSS badge ───────────────────────────────────────────────────
const Badge = ({ present }) => (
  <span style={{
    display: 'inline-block',
    padding: '3px 12px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 700,
    backgroundColor: present ? '#d4edda' : '#f8d7da',
    color:           present ? '#155724' : '#721c24',
    letterSpacing: '0.3px',
  }}>
    {present ? '✅ Present' : '❌ Absent'}
  </span>
);

// ─── Summary card (modal top row) ────────────────────────────────────────────
const SummaryCard = ({ label, value, bg, color }) => (
  <div style={{
    flex: 1, minWidth: 100, padding: '14px 10px',
    borderRadius: 12, backgroundColor: bg,
    textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,.07)',
  }}>
    <div style={{ fontSize: 28, fontWeight: 800, color, lineHeight: 1 }}>{value}</div>
    <div style={{ fontSize: 11, color: '#555', marginTop: 4, fontWeight: 600,
      textTransform: 'uppercase', letterSpacing: '0.6px' }}>{label}</div>
  </div>
);

// ─── Professional Excel export ────────────────────────────────────────────────
/**
 * Builds a richly formatted .xlsx with:
 *  • Cover section  – course meta + summary KPIs
 *  • Attendance table – colour-coded rows, frozen header, auto-width columns
 */
const buildProfessionalExcel = ({
  attendanceRecords,
  batchDetails,
  intakeId1,
  intakedata,
  selectedSessionId,
  formatDate,
  formatToDDMMYYYY,
}) => {
  const wb = XLSX.utils.book_new();
  const ws = {};

  // ── helpers ────────────────────────────────────────────────────────────────
  const cell = (r, c, v, t = 's') => {
    const addr = XLSX.utils.encode_cell({ r, c });
    ws[addr] = { v, t };
  };

  const styledCell = (r, c, v, style, t = 's') => {
    const addr = XLSX.utils.encode_cell({ r, c });
    ws[addr] = { v, t, s: style };
  };

  // Shared style builders
  const headerStyle = (bgHex = COLORS.headerBg) => ({
    font:      { name: 'Arial', bold: true, color: { rgb: COLORS.headerText }, sz: 11 },
    fill:      { patternType: 'solid', fgColor: { rgb: bgHex } },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    border:    {
      top:    { style: 'thin', color: { rgb: 'AAAAAA' } },
      bottom: { style: 'thin', color: { rgb: 'AAAAAA' } },
      left:   { style: 'thin', color: { rgb: 'AAAAAA' } },
      right:  { style: 'thin', color: { rgb: 'AAAAAA' } },
    },
  });

  const labelStyle = () => ({
    font:      { name: 'Arial', bold: true, sz: 10, color: { rgb: '1A3C6E' } },
    fill:      { patternType: 'solid', fgColor: { rgb: 'EEF2FF' } },
    alignment: { horizontal: 'left', vertical: 'center' },
    border:    { bottom: { style: 'hair', color: { rgb: 'CCCCCC' } } },
  });

  const valueStyle = () => ({
    font:      { name: 'Arial', sz: 10 },
    alignment: { horizontal: 'left', vertical: 'center' },
    border:    { bottom: { style: 'hair', color: { rgb: 'CCCCCC' } } },
  });

  const kpiStyle = (bgHex) => ({
    font:      { name: 'Arial', bold: true, sz: 14, color: { rgb: COLORS.accent } },
    fill:      { patternType: 'solid', fgColor: { rgb: bgHex } },
    alignment: { horizontal: 'center', vertical: 'center' },
    border:    {
      top:    { style: 'medium', color: { rgb: COLORS.accent } },
      bottom: { style: 'medium', color: { rgb: COLORS.accent } },
      left:   { style: 'medium', color: { rgb: COLORS.accent } },
      right:  { style: 'medium', color: { rgb: COLORS.accent } },
    },
  });

  const kpiLabelStyle = (bgHex) => ({
    font:      { name: 'Arial', bold: true, sz: 9, color: { rgb: '444444' } },
    fill:      { patternType: 'solid', fgColor: { rgb: bgHex } },
    alignment: { horizontal: 'center', vertical: 'center' },
    border:    {
      bottom: { style: 'medium', color: { rgb: COLORS.accent } },
      left:   { style: 'medium', color: { rgb: COLORS.accent } },
      right:  { style: 'medium', color: { rgb: COLORS.accent } },
    },
  });

  const dataRowStyle = (alt, statusColor) => ({
    font:      { name: 'Arial', sz: 10, color: { rgb: statusColor || '000000' } },
    fill:      { patternType: 'solid', fgColor: { rgb: alt ? COLORS.rowAlt : 'FFFFFF' } },
    alignment: { horizontal: 'left', vertical: 'center' },
    border:    {
      top:    { style: 'hair', color: { rgb: 'DDDDDD' } },
      bottom: { style: 'hair', color: { rgb: 'DDDDDD' } },
      left:   { style: 'hair', color: { rgb: 'DDDDDD' } },
      right:  { style: 'hair', color: { rgb: 'DDDDDD' } },
    },
  });

  // ── Title banner (row 0) ───────────────────────────────────────────────────
  styledCell(0, 0, 'SESSION ATTENDANCE REPORT', {
    font:      { name: 'Arial', bold: true, sz: 16, color: { rgb: 'FFFFFF' } },
    fill:      { patternType: 'solid', fgColor: { rgb: COLORS.headerBg } },
    alignment: { horizontal: 'center', vertical: 'center' },
  });
  // Blank filler cells in the merged range
  for (let c = 1; c <= 5; c++) {
    styledCell(0, c, '', {
      fill: { patternType: 'solid', fgColor: { rgb: COLORS.headerBg } },
    });
  }

  // ── Meta info block (rows 2-7) ─────────────────────────────────────────────
  const trainers   = Array.isArray(intakedata?.trainers) && intakedata.trainers.length
    ? intakedata.trainers.join(', ') : 'N/A';
  const assessors  = Array.isArray(intakedata?.assessors) && intakedata.assessors.length
    ? intakedata.assessors.join(', ') : 'N/A';
  const startDate  = intakedata?.scheduleDateDetails?.[0]?.startDate
    ? formatToDDMMYYYY(intakedata.scheduleDateDetails[0].startDate) : 'N/A';
  const endDate    = intakedata?.scheduleDateDetails?.length
    ? formatToDDMMYYYY(
        intakedata.scheduleDateDetails[intakedata.scheduleDateDetails.length - 1].endDate
      ) : 'N/A';

  const metaRows = [
    ['Course',        batchDetails?.course || 'N/A'],
    ['Intake ID',     intakeId1 || 'N/A'],
    ['Session ID',    selectedSessionId || 'N/A'],
    ['Trainers',      trainers],
    ['Assessors',     assessors],
    ['Course Period', `${startDate} → ${endDate}`],
  ];

  metaRows.forEach(([lbl, val], i) => {
    const row = i + 2;
    styledCell(row, 0, lbl, labelStyle());
    styledCell(row, 1, val, valueStyle());
    // fill remaining cols so the row doesn't look blank
    for (let c = 2; c <= 5; c++) {
      styledCell(row, c, '', { fill: { patternType: 'solid', fgColor: { rgb: 'FFFFFF' } } });
    }
  });

  // ── KPI summary cards (row 9-10) ──────────────────────────────────────────
  const presentCount = attendanceRecords.filter(r => r.status === 'Present').length;
  const absentCount  = attendanceRecords.length - presentCount;
  const pct          = attendanceRecords.length
    ? Math.round((presentCount / attendanceRecords.length) * 100) : 0;

  const kpis = [
    { label: 'PRESENT',      value: presentCount,         bg: COLORS.summaryGreen },
    { label: 'ABSENT',       value: absentCount,          bg: COLORS.summaryRed   },
    { label: 'TOTAL',        value: attendanceRecords.length, bg: COLORS.summaryBlue },
    { label: 'ATTENDANCE %', value: `${pct}%`,            bg: COLORS.summaryAmber },
  ];

  kpis.forEach(({ label, value, bg }, i) => {
    styledCell(9,  i * 2,     value,  kpiStyle(bg),      typeof value === 'number' ? 'n' : 's');
    styledCell(9,  i * 2 + 1, '',     kpiStyle(bg));
    styledCell(10, i * 2,     label,  kpiLabelStyle(bg));
    styledCell(10, i * 2 + 1, '',     kpiLabelStyle(bg));
  });

  // ── Attendance table header (row 12) ──────────────────────────────────────
  const TABLE_HEADERS = ['S.No', 'Student Name', 'Status', 'Joined At', 'Left At', 'Duration (mins)'];
  TABLE_HEADERS.forEach((h, c) => styledCell(12, c, h, headerStyle()));

  // ── Attendance data rows (from row 13) ────────────────────────────────────
  attendanceRecords.forEach((record, idx) => {
    const row   = 13 + idx;
    const alt   = idx % 2 === 0;
    const isPresent = record.status === 'Present';
    const statusBgHex = isPresent ? COLORS.presentBg : COLORS.absentBg;
    const statusTxtHex = isPresent ? COLORS.presentText : COLORS.absentText;

    const dur = record.durationMinutes != null
      ? parseFloat(record.durationMinutes).toFixed(2) : '—';

    const cells = [
      [idx + 1,              'n', null],
      [record.studentName,   's', null],
      [record.status,        's', { // coloured status cell
        font:      { name: 'Arial', bold: true, sz: 10, color: { rgb: statusTxtHex } },
        fill:      { patternType: 'solid', fgColor: { rgb: statusBgHex } },
        alignment: { horizontal: 'center', vertical: 'center' },
        border:    {
          top: { style: 'hair', color: { rgb: 'DDDDDD' } },
          bottom: { style: 'hair', color: { rgb: 'DDDDDD' } },
          left: { style: 'hair', color: { rgb: 'DDDDDD' } },
          right: { style: 'hair', color: { rgb: 'DDDDDD' } },
        },
      }],
      [record.joinedAt ? formatDate(record.joinedAt) : '—', 's', null],
      [record.leftAt   ? formatDate(record.leftAt)   : '—', 's', null],
      [dur,                  's', null],
    ];

    cells.forEach(([v, t, customStyle], c) => {
      styledCell(row, c, v, customStyle || dataRowStyle(alt), t);
    });
  });

  // ── Sheet range ───────────────────────────────────────────────────────────
  const lastRow = 13 + attendanceRecords.length - 1;
  ws['!ref'] = XLSX.utils.encode_range({ r: 0, c: 0 }, { r: lastRow, c: 5 });

  // ── Merges ────────────────────────────────────────────────────────────────
  ws['!merges'] = [
    // Title banner
    { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
    // Meta value cells span cols 1-5
    ...metaRows.map((_, i) => ({ s: { r: i + 2, c: 1 }, e: { r: i + 2, c: 5 } })),
    // KPI pairs
    { s: { r: 9,  c: 0 }, e: { r: 9,  c: 1 } },
    { s: { r: 9,  c: 2 }, e: { r: 9,  c: 3 } },
    { s: { r: 9,  c: 4 }, e: { r: 9,  c: 5 } },
    { s: { r: 9,  c: 6 }, e: { r: 9,  c: 7 } },  // note: 4 KPIs × 2 cols = cols 0-7
    { s: { r: 10, c: 0 }, e: { r: 10, c: 1 } },
    { s: { r: 10, c: 2 }, e: { r: 10, c: 3 } },
    { s: { r: 10, c: 4 }, e: { r: 10, c: 5 } },
    { s: { r: 10, c: 6 }, e: { r: 10, c: 7 } },
  ];

  // ── Column widths ─────────────────────────────────────────────────────────
  ws['!cols'] = [
    { wch: 7  },   // S.No
    { wch: 28 },   // Student Name
    { wch: 12 },   // Status
    { wch: 22 },   // Joined At
    { wch: 22 },   // Left At
    { wch: 16 },   // Duration
  ];

  // ── Row heights ───────────────────────────────────────────────────────────
  ws['!rows'] = [
    { hpt: 36 },   // row 0 — title
  ];

  // ── Freeze panes at the table header ─────────────────────────────────────
  ws['!freeze'] = { xSplit: 0, ySplit: 13, topLeftCell: 'A14' };

  XLSX.utils.book_append_sheet(wb, ws, 'Attendance');

  // ── Trigger download ──────────────────────────────────────────────────────
  const buf  = XLSX.write(wb, { bookType: 'xlsx', type: 'array', cellStyles: true });
  const blob = new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url  = window.URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = `attendance_${selectedSessionId || 'session'}.xlsx`;
  a.click();
  window.URL.revokeObjectURL(url);
};

// ═══════════════════════════════════════════════════════════════════════════════
// Main component
// ═══════════════════════════════════════════════════════════════════════════════
const BatchDetails = () => {
  const { batchId, intakeId } = useParams();
  const batchId1  = decryptData(decodeURIComponent(batchId));
  const intakeId1 = decryptData(decodeURIComponent(intakeId));

  const [batchDetails,      setBatchDetails]      = useState(null);
  const [loading,           setLoading]           = useState(true);
  const [matchingSessions,  setMatchingSessions]  = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState(null);
  const [showModal,         setShowModal]         = useState(false);
  const [page,              setPage]              = useState(0);
  const [rowsPerPage,       setRowsPerPage]       = useState(5);
  const [intakedata,        setIntakedata]        = useState([]);

  // ── NEW: DB-driven attendance state ───────────────────────────────────────
  const [attendanceRecords,  setAttendanceRecords]  = useState([]);
  const [attendanceLoading,  setAttendanceLoading]  = useState(false);
  // Track which sessions already have saved records (for the table badge)
  const [savedSessionIds,    setSavedSessionIds]    = useState(new Set());

  // Pagination helpers
  const indexOfLastSession  = (page + 1) * rowsPerPage;
  const indexOfFirstSession = indexOfLastSession - rowsPerPage;
  const currentSessions     = matchingSessions.slice(indexOfFirstSession, indexOfLastSession);

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  // ── Fetch batch details ───────────────────────────────────────────────────
  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`batch/${batchId1}`);
        setBatchDetails(res.data);
      } catch (e) {
        console.error('Error fetching batch details:', e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [batchId1]);

  // ── Fetch intake details ──────────────────────────────────────────────────
  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`/intake-details/intake/${intakeId1}`);
        if (res.data) setIntakedata(res.data);
      } catch (e) {
        console.error('Fetch error:', e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [intakeId1]);

  // ── Fetch Dyte sessions ───────────────────────────────────────────────────
  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const authHeader = `Basic ${btoa(`${Username}:${Password}`)}`;
        const res = await axios.get(`${baseURLdyte}/sessions`, {
          headers: { Authorization: authHeader },
        });
        const sessions = res.data.data.sessions;
        if (batchDetails && sessions) {
          const url   = batchDetails.onlineclasslink;
          const match = url.match(/id=([a-f\d-]+)/i);
          if (match && match[1]) {
            setMatchingSessions(
              sessions.filter(s => s.meta.room_name === match[1])
            );
          }
        }
      } catch (e) {
        console.error('Error fetching sessions:', e);
      }
    };
    fetchSessions();
  }, [batchDetails]);

  // ── Check which sessions already have attendance saved ────────────────────
  useEffect(() => {
    if (!matchingSessions.length) return;
    const check = async () => {
      try {
        const res = await axios.get(
          `/online-meeting/meeting-attendance/${batchId1}/${intakeId1}`
        );
        setSavedSessionIds(new Set(res.data.map(r => r.sessionId)));
      } catch (e) {
        console.error('Error checking saved attendance:', e);
      }
    };
    check();
  }, [matchingSessions, batchId1, intakeId1]);

  // ── Open modal: load attendance from DB ───────────────────────────────────
  const handleSessionButtonClick = async (sessionId) => {
    setSelectedSessionId(sessionId);
    setShowModal(true);
    setAttendanceLoading(true);
    setAttendanceRecords([]);

    try {
      const res = await axios.get(
        `/online-meeting/meeting-attendance/${batchId1}/${intakeId1}`
      );
      setAttendanceRecords(res.data.filter(r => r.sessionId === sessionId));
    } catch (e) {
      console.error('Error fetching attendance:', e);
      setAttendanceRecords([]);
    } finally {
      setAttendanceLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setAttendanceRecords([]);
  };

  // ── Date / duration formatters ─────────────────────────────────────────────
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString(undefined, {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
  };

  const convertSecondsToMinutes = (seconds) => (seconds / 60).toFixed(2);

  function formatToDDMMYYYY(dateString) {
    if (!dateString) return 'Invalid Date';
    const d = new Date(dateString);
    if (isNaN(d)) return 'Invalid Date';
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
  }

  // ── Excel download ────────────────────────────────────────────────────────
  const downloadSessionDetailsToExcel = () => {
    if (!attendanceRecords.length) {
      alert('No attendance data to export.');
      return;
    }
    buildProfessionalExcel({
      attendanceRecords,
      batchDetails,
      intakeId1,
      intakedata,
      selectedSessionId,
      formatDate,
      formatToDDMMYYYY,
    });
  };

  // ── KPI helpers ───────────────────────────────────────────────────────────
  const presentCount = attendanceRecords.filter(r => r.status === 'Present').length;
  const absentCount  = attendanceRecords.length - presentCount;
  const attendancePct = attendanceRecords.length
    ? Math.round((presentCount / attendanceRecords.length) * 100) : 0;

  // ── Session table ─────────────────────────────────────────────────────────
  const renderSessionTable = () => {
    let validRowIndex = 0;
    return (
      <div className="container-responsive mt-4">
        {matchingSessions.length >= 0 && (
          <Table striped bordered hover responsive style={{ width: '100%', tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow style={{ backgroundColor: '#1A3C6E' }}>
                {['S.No', 'Meeting Name', 'Duration', 'Starting At', 'Ending At', 'Attendance', 'Action'].map(col => (
                  <TableCell key={col} sx={{ fontWeight: 'bold', color: '#fff !important',
                    backgroundColor: '#1A3C6E !important', fontSize: '13px' }}>
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {currentSessions.map((session) => (
                session.total_participants !== 0 && (
                  <TableRow key={session.id} hover>
                    <TableCell>{++validRowIndex}</TableCell>
                    <TableCell>{session.meeting_display_name}</TableCell>
                    <TableCell>{convertSecondsToMinutes(session.minutes_consumed)} hrs</TableCell>
                    <TableCell>{formatDate(session.started_at)}</TableCell>
                    <TableCell>{formatDate(session.ended_at)}</TableCell>

                    {/* Attendance saved badge */}
                    <TableCell>
                      {savedSessionIds.has(session.id) ? (
                        <span style={{
                          backgroundColor: '#d4edda', color: '#155724',
                          padding: '4px 12px', borderRadius: 12,
                          fontSize: 12, fontWeight: 700,
                        }}>✓ Saved</span>
                      ) : (
                        <span style={{
                          backgroundColor: '#fff3cd', color: '#856404',
                          padding: '4px 12px', borderRadius: 12,
                          fontSize: 12, fontWeight: 700,
                        }}>Pending</span>
                      )}
                    </TableCell>

                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => handleSessionButtonClick(session.id)}
                        sx={{ backgroundColor: '#1A3C6E', '&:hover': { backgroundColor: '#14305a' } }}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                )
              ))}
            </TableBody>
          </Table>
        )}
        <TablePagination
          component="div"
          count={matchingSessions.filter(s => s.total_participants !== 0).length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    );
  };

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <div>
      {loading && <Loader />}
      {!loading && (
        <TableContainer sx={{ maxHeight: 'none' }}>
          {renderSessionTable()}
        </TableContainer>
      )}

      {/* ── Attendance Modal ─────────────────────────────────────────────── */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="fullscreen">

        {/* Header */}
        <Modal.Header closeButton style={{ backgroundColor: '#1A3C6E', color: 'white' }}>
          <Modal.Title style={{ fontSize: 22, fontWeight: 700, letterSpacing: '0.3px' }}>
            Session Attendance
            <span style={{ fontSize: 13, fontWeight: 400, marginLeft: 14, opacity: 0.8 }}>
              {selectedSessionId}
            </span>
          </Modal.Title>
        </Modal.Header>

        {/* Body */}
        <Modal.Body style={{ backgroundColor: '#f8fafc', padding: '28px 32px' }}>

          {attendanceLoading ? (
            <div style={{ textAlign: 'center', padding: '60px 0' }}>
              <div className="spinner-border text-primary" role="status" />
              <p style={{ marginTop: 14, color: '#555', fontSize: 15 }}>
                Loading attendance records…
              </p>
            </div>

          ) : attendanceRecords.length === 0 ? (
            <div style={{
              textAlign: 'center', padding: '60px 24px',
              backgroundColor: 'white', borderRadius: 12,
              boxShadow: '0 1px 6px rgba(0,0,0,.07)',
            }}>
              <div style={{ fontSize: 44, marginBottom: 12 }}>📋</div>
              <div style={{ fontSize: 17, fontWeight: 600, color: '#333', marginBottom: 6 }}>
                No attendance records found for this session.
              </div>
              <div style={{ fontSize: 13, color: '#888' }}>
                Attendance is automatically saved via webhook when the meeting ends.
              </div>
            </div>

          ) : (
            <>
              {/* ── KPI summary row ──────────────────────────────────────── */}
              <div style={{ display: 'flex', gap: 14, marginBottom: 24, flexWrap: 'wrap' }}>
                <SummaryCard label="Present"      value={presentCount}   bg="#dcfce7" color="#15803d" />
                <SummaryCard label="Absent"       value={absentCount}    bg="#ffe4e6" color="#be123c" />
                <SummaryCard label="Total"        value={attendanceRecords.length} bg="#dbeafe" color="#1d4ed8" />
                <SummaryCard label="Attendance %" value={`${attendancePct}%`}      bg="#fef9c3" color="#a16207" />
              </div>

              {/* ── Attendance table ──────────────────────────────────────── */}
              <Paper sx={{ borderRadius: '10px', overflow: 'hidden',
                boxShadow: '0 2px 12px rgba(0,0,0,.08)' }}>
                <TableContainer>
                  <Table aria-label="attendance table" size="small">
                    <TableHead>
                      <TableRow>
                        {['S.No', 'Student Name', 'Status', 'Joined At', 'Left At', 'Duration'].map(col => (
                          <TableCell
                            key={col}
                            sx={{
                              fontWeight: 700,
                              color: '#fff !important',
                              backgroundColor: '#1A3C6E !important',
                              fontSize: '13px',
                              py: 1.5,
                              letterSpacing: '0.4px',
                            }}
                          >
                            {col}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {attendanceRecords.map((record, index) => (
                        <TableRow
                          key={record.id || index}
                          hover
                          sx={{
                            backgroundColor: record.status === 'Absent'
                              ? '#fff5f5'
                              : index % 2 === 0 ? '#f0f4ff' : 'white',
                            transition: 'background-color .15s',
                          }}
                        >
                          <TableCell sx={{ color: '#555', fontWeight: 500 }}>
                            {index + 1}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, color: '#1a1a1a' }}>
                            {record.studentName}
                          </TableCell>
                          <TableCell>
                            <Badge present={record.status === 'Present'} />
                          </TableCell>
                          <TableCell sx={{ fontSize: 13, color: '#444' }}>
                            {record.joinedAt ? formatDate(record.joinedAt) : '—'}
                          </TableCell>
                          <TableCell sx={{ fontSize: 13, color: '#444' }}>
                            {record.leftAt ? formatDate(record.leftAt) : '—'}
                          </TableCell>
                          <TableCell sx={{ fontSize: 13, color: '#444', fontWeight: 500 }}>
                            {record.durationMinutes != null
                              ? `${parseFloat(record.durationMinutes).toFixed(2)} mins`
                              : '—'}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </>
          )}
        </Modal.Body>

        {/* Footer */}
        <Modal.Footer style={{ backgroundColor: '#f1f5f9', borderTop: '1px solid #e2e8f0', gap: 10 }}>
          <button
            onClick={handleCloseModal}
            style={{
              background: '#dc2626', color: 'white', border: 'none',
              padding: '9px 32px', borderRadius: 8,
              fontSize: 15, fontWeight: 600, cursor: 'pointer',
              transition: 'background .2s',
            }}
          >
            Close
          </button>

          {attendanceRecords.length > 0 && (
            <button
              onClick={downloadSessionDetailsToExcel}
              style={{
                background: 'linear-gradient(135deg, #166534, #15803d)',
                color: 'white', border: 'none',
                padding: '9px 28px', borderRadius: 8,
                fontSize: 15, fontWeight: 600, cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: 8,
                boxShadow: '0 2px 8px rgba(22,101,52,.35)',
                transition: 'opacity .2s',
              }}
            >
              <SaveAltIcon style={{ fontSize: 18 }} />
              Download Excel
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BatchDetails;